import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4851e878"), n = n(), _popScopeId(), n);
const _hoisted_1 = { style: { "text-align": "center" } };
const _hoisted_2 = { class: "subtitle" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoadingPage',
    props: {
        label: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoadingSpinner, {
                    size: "large",
                    style: { "margin-bottom": "10px", "margin-top": "30px" }
                }),
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.label || 'Loading...'), 1)
            ]));
        };
    }
});
